import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { blueGrey } from '@material-ui/core/colors';

import Button from '../Button';
import Down from '../../assets/icons/down.svg';

const Icon = styled.img`
  width: 10px;
  height: 6px;
  margin-left: 2px;
`;

const Base = React.forwardRef(
  (
    { options, setOpen, value, disabled, color, placeholder },
    ref
  ) => {
    const [title, setTitle] = React.useState('');

    function openMenu() {
      setOpen(true);
    }

    function resetMenu() {
      setOpen(false);
    }

    function updateTitle() {
      options.forEach(({ title: _title, value: _value }) => {
        if (value === _value) setTitle(_title);
      });
    }

    React.useEffect(updateTitle, [value]);
    React.useEffect(resetMenu, [disabled]);

    return (
      <Button
        big
        thin
        ref={ref}
        key="base"
        color={color}
        outlined={false}
        onClick={openMenu}
        disabled={disabled}
      >
        {title || placeholder}
        <Icon alt="down" src={Down} />
      </Button>
    );
  }
);

Base.propTypes = {
  color: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  setOpen: PropTypes.func.isRequired,
};

Base.defaultProps = {
  value: '',
  disabled: false,
  color: blueGrey[800],
  placeholder: 'Select',
};

export default Base;
